import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { EventType } from "../SchedulingTypes";

const EmployeeEventTooltip: React.FC<{ event: EventType, x: number, y: number }> = ({ event, x, y }) => {
    const { t } = useTranslation();
    const [pos, setPosition] = useState({ top: 0, left: 0 });
    const [visible, setVisible] = useState(false);
    const [ready, setReady] = useState(false);
    const tooltipRef = useRef<HTMLDivElement | null>(null);
    const timerRef = useRef<NodeJS.Timeout | null>(null);

    // Show the tooltip after a slight delay
    useEffect(() => {
        setVisible(false);
        setReady(false);

        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }

        if (event) {
            const id = setTimeout(() => {
                setVisible(true);
            }, 125);

            timerRef.current = id;
        }

        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, [event]);

    // Calculate the last given position and set ready to prevent flickering
    useEffect(() => {
        if (!event || !tooltipRef.current) return;

        // Get the tooltip rect
        const rect = tooltipRef.current.getBoundingClientRect();

        // Get the view width and height
        const viewWidth = window.innerWidth;
        const viewHeight = window.innerHeight;

        // Set the offset from the side to 12 pixels
        const offset = 12;

        // Get the left and top position with the offset
        let left = x + offset;
        let top = y + offset;

        // Prevent right overflow
        if (left + rect.width > viewWidth) {
            left = x - rect.width - offset;
        }

        // Prevent bottom overflow
        if (top + rect.height > viewHeight) {
            top = y - rect.height - offset;
        }

        // Clamp
        if (left < offset) left = offset;
        if (top < offset) top = offset;

        setPosition({ top, left });
        setReady(true);
    }, [event, x, y]);

    if (!event) return null;

    // Determine is visible state
    const isVisible = visible && ready;

    return (
        <div ref={tooltipRef}
             className="event-tooltip"
             style={{
                position: "fixed",
                top: ready ? pos.top : -9999,
                left: ready ? pos.left : -9999,
                visibility: isVisible ? "visible" : "hidden",
                opacity: isVisible ? 1 : 0,
            }}>
            {event.type === "individualJobEmployeeEvent" && (
                <div className="activity-event">
                    <div className="tooltip-header">
                        <h6>{event.assigneeName}</h6>
                        <div className="tooltip-time">
                            {event.startTime} – {event.endTime}
                        </div>
                    </div>
                    {/* {event.note && <div className="tooltip-content">{event.note}</div>} */}
                </div>
            )}
        </div>
    );
};

export default EmployeeEventTooltip;